import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/salaInfo.css";

export function SalaInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllSalaBrigadaById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    const convertBoll = (check) => {
        if (check === 0) return "Não Conforme";
        return "Conforme";
    };

    console.log(data.length);

    return (
        <div>
            <div className="container-sala-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">
                        Verificação de equipamentos de atendimento a emergência
                        - Sala da Brigada
                    </h1>
                </div>
                {data.length > 0 ? data.map((check, i) => {
                    return (
                        <main className="datagrid-container">
                            <div className="table-content">
                                <div key={i}>
                                        <div>
                                            <h3 className="subtitle-sala-info">{check.item}</h3>
                                        </div>
                                    <thead>
                                        <tr>
                                            <th>Cenário de aplicação</th>
                                            <th>Quantidade miníma necessária</th>
                                            <th>Quantidade encontrada</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.cenario
                                                ? check.cenario
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.qnt_minima
                                                ? check.qnt_minima
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.qnt_encontrada
                                                ? check.qnt_encontrada
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Quantidade C/NC</th>
                                            <th>Condições dos equipamentos C/NC</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.qnt_c_nc
                                                ? check.qnt_c_nc
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.condicao_equip_c_nc
                                                ? convertBoll(check.condicao_equip_c_nc)
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                }) : <h2 className="subtitle-sala-info">Não há verificação de equipamentos</h2>}
            </div>
        </div>
    );
}
